import { __decorate } from "tslib";
import { Component, Mixins, Inject } from 'vue-property-decorator';
import PageTitle from '@/components/v2/PageTitle.vue';
import PromoCodeManager from '@/components/v2/PromoCodeManager.vue';
import ActionButton from '@/components/action_button/Index.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import { INSURANCE, SHOPIFY } from '@/helpers/constants/Bundles';
import AppBundle from '@/plugins/graphql/queries/v2/app-bundle.gql';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import ButtonLoaderMixin from '@/helpers/vue_mixins/ButtonLoaderMixin';
import SyncPromoCodes from '@/plugins/graphql/mutations/v2/shopify/sync-promo-codes.gql';
import GraphqlErrorMixin from '@/helpers/vue_mixins/GraphqlErrorMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import AppBasicDetails from '@/components/v2/AppBasicDetails';
import moment from 'moment';
import BaseOverlayLoader from '@/components/v2/BaseOverlayLoader';
import AppShopifySetting from '@/plugins/graphql/queries/app-shopify-setting.gql';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
import ConfirmationDialog from '@/components/BaseConfirmDialog.vue';
import AutomaticDiscountManager from '@/components/v2/AutomaticDiscountManager.vue';
let PromoCodes = class PromoCodes extends Mixins(ViewportSizeMixin, AlertMixin, ButtonLoaderMixin, GraphqlErrorMixin, Mixins(RouterParamsAppMixin, CleverTapEventsMixin)) {
    constructor() {
        super(...arguments);
        this.tab = 0;
        this.shopifySetting = null;
        this.isReady = false;
        this.toggleConfirm = false;
    }
    get isShopifyBundle() {
        return this.appBundle === SHOPIFY;
    }
    get isInsuranceBundle() {
        return this.appBundle === INSURANCE;
    }
    get shopifyAppUuid() {
        return this.$route.params.appUUID || this.appUUID;
    }
    async syncPromoCodes() {
        // if (!this.shopifySetting) {
        //   this.errorNotification('Syncing failed. Update your Shopify App Credentials.');
        //   return;
        // }
        this.voucherAction('START VOUCHER SYNCING');
        this.requestOnFlight();
        this.toggleConfirm = false;
        await this.$apollo
            .mutate({
            mutation: SyncPromoCodes,
            variables: {
                input: {
                    appUuid: this.appUUID,
                },
            },
        })
            .then(() => {
            this.voucherAction('FINISH VOUCHER SYNCING');
            this.updatePromoCodeSyncStatus(true);
        })
            .catch((e) => {
            this.errorNotification(e.message);
            this.logError(e.message);
        })
            .finally(() => {
            this.requestDone();
        });
    }
    get headers() {
        return [
            {
                text: 'CODE',
                value: 'code',
                align: 'left',
                sortable: false,
            },
            {
                text: 'VALUE',
                value: 'value',
                align: 'left',
                sortable: false,
                isCurrency: true,
            },
            {
                text: 'USAGE LIMIT  ',
                value: 'usageLimit',
                align: 'left',
                sortable: false,
            },
            {
                text: 'DURATION',
                value: 'duration',
                align: 'left',
                sortable: false,
            },
            {
                text: 'USAGE COUNT',
                value: 'usageCount',
                align: 'left',
                sortable: false,
            },
            {
                text: 'ACTIVE',
                value: 'active',
                align: 'left',
                sortable: false,
                switchable: true,
            },
            {
                text: '',
                value: '',
                align: '',
                sortable: false,
            },
        ];
    }
    get autoHeaders() {
        return [
            {
                text: 'DISCOUNT NAME',
                value: 'discount name',
                align: 'left',
                sortable: false,
            },
            {
                text: 'VALUE',
                value: 'value',
                align: 'left',
                sortable: false,
                isCurrency: true,
            },
            {
                text: 'USAGE LIMIT  ',
                value: 'usageLimit',
                align: 'left',
                sortable: false,
            },
            {
                text: 'DURATION',
                value: 'duration',
                align: 'left',
                sortable: false,
            },
            {
                text: 'USED',
                value: 'used',
                align: 'left',
                sortable: false,
            },
            {
                text: 'ACTIVE',
                value: 'active',
                align: 'left',
                sortable: false,
                switchable: true,
            },
            {
                text: '',
                value: '',
                align: '',
                sortable: false,
            },
        ];
    }
    formatValueType(valueType, value) {
        if (valueType === 'absolute') {
            return `₱ ${value}`;
        }
        return `${value}%`;
    }
    get loadingTitle() {
        return 'Syncing Shopify Discount Codes';
    }
    lastSyncTextDetails(date) {
        return `Shopify Discounts are updated as of ${moment(date).format('MMMM DD, YYYY hh:mm a')}`;
    }
    get discountTabOptions() {
        return [
            { name: 'Voucher Codes', serial: 0 },
            { name: 'Automatic Discounts', serial: 1 },
        ];
    }
    switchTab(serial) {
        this.tab = serial;
    }
    async mounted() {
        if (this.isInsuranceBundle) {
            this.isReady = false;
        }
        else {
            this.isReady = true;
        }
        await this.$nextTick();
        this.viewVouchersPage();
        const savedTab = localStorage.getItem('tab');
        localStorage.removeItem('tab');
        if (savedTab !== null) {
            this.tab = parseInt(savedTab, 10);
        }
        else {
            this.tab = 0;
        }
    }
    async updated() {
        await this.$nextTick();
    }
    toggleConfirmation() {
        this.toggleConfirm = true;
    }
};
__decorate([
    Inject()
], PromoCodes.prototype, "shopifyPromoCodeSyncing", void 0);
__decorate([
    Inject()
], PromoCodes.prototype, "updatePromoCodeSyncStatus", void 0);
PromoCodes = __decorate([
    Component({
        components: {
            PageTitle,
            PromoCodeManager,
            ActionButton,
            AppBasicDetails,
            BaseOverlayLoader,
            ConfirmationDialog,
            AutomaticDiscountManager,
        },
        apollo: {
            appBundle: {
                query: AppBundle,
                variables() {
                    return { appUuid: this.appUUID };
                },
                update(data) {
                    return data.appServiceBundle.name;
                },
            },
            shopifySetting: {
                query: AppShopifySetting,
                variables() {
                    return { appUUID: this.shopifyAppUuid };
                },
                update(data) {
                    return data.app.shopifySetting;
                },
            },
        },
    })
], PromoCodes);
export default PromoCodes;
